import React, { useState } from "react";
import Dropzone from "react-dropzone";
import CloudUploadImg from "../../DRM/assets/images/cloud-upload.png";
import { useNavigate } from "react-router-dom";
import { displayLog, getFileName, stopUploadDialogue } from "../common/common";
import config from "../common/config";
import { axios_tenant } from "../../../../axios";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

const SUPPORTED_FILES = ["xlsx", "xls", "xlsb", "csv", "xml"];

const DocketsUpload = (props) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [uploadedFiles, setUploadedFiles] = useState({});

	const uploadFile = async () => {
		setLoading(true);
	
		// ----------------------------
		// CATEGORY VALIDATION (NEW)
		// ----------------------------
		const FIP_FILES = [
			"WorkingStmtPA", "OpenDocketPA", "IndiaMattersPA",
			"ClosedDocketPA", "BibliographicPA", "PAIRPA",
			"ClosedDocketTM", "BibliographicTM"
		];
	
		const CPI_FILES = [
			"CPI_BibliographyTM", "CPI_Create_ActionTM", "CPI_Last_ActionTM", "User Name"
		];

		const Finnegan_FILES = ['90dayOutput'];
		const InproTech_FILES = ['TREXO-DRM-BIBLIOGRAPHICPA', 'TREXO-DRM-OPENDOCKETPA', 'TREXO-DRMINDIAMATTERSPA', 'TREXO-WORKINGSTMTPA','TREXO-DRM-BIBLIOGRAPHICTM'];

	
		const fipSet = new Set(FIP_FILES.map(f => f.toUpperCase()));
		const cpiSet = new Set(CPI_FILES.map(f => f.toUpperCase()));
		const inproTechSet = new Set(InproTech_FILES.map(f => f.toUpperCase()));
		// Extract filename without extension
		const uploadedNames = uploadedFiles.map(f =>
			getFileName(f.name).split(".")[0].toUpperCase()
		);
	
		const hasFip = uploadedNames.some(n => fipSet.has(n));
		const hasCpi = uploadedNames.some(n => cpiSet.has(n));
	    const hasInproTech = uploadedNames.some(n => inproTechSet.has(n));
		//  Mixed Category Blocker
		if (hasFip && hasCpi && hasInproTech) {
			displayLog("You cannot upload FIP, CPI, and InproTech files together.", "error");
			setLoading(false);
			return;
		}
	
		// ----------------------------
		// ORIGINAL VALIDATION
		// ----------------------------
		let errorCount = 0;
		let errorData = 'The following warnings / errors have occurred<br/><br/><ul>';

		let alreadyUploaded = new Set();

		for (let file of uploadedFiles) {
			const newFileName = getFileName(file.name).split(".")[0];

			if (newFileName == "notFound") {
				errorCount++;
				errorData += `<li> File name ${file.name} is not in the list of allowed files. </li>`
			}
			else if (alreadyUploaded.has(newFileName)) {
				errorCount++;
				errorData += `<li>There are multiple files with name ${file.name}.</li>`
			}
			else {
				alreadyUploaded.add(newFileName);
			}
		}

		let cnfrm = false;
		if (errorCount != 0) {
			cnfrm = await stopUploadDialogue(errorData);
		}
		else {
			if (!cnfrm) {
				for (let file of uploadedFiles) {
					let formData = new FormData();

					formData.append("file", file);

					const newFileName = getFileName(file.name);

					await axios_tenant.post(`/drm/uploadFile?fileName=${newFileName}`, formData).then((res) => res.data);

				}
				navigate("/drm/file-upload/files");
			}
			else {
				window.location.reload(false);
				// return
			}

		}
		setLoading(true);

	};

	const fileDrop = (files) => {
    let duplicateFiles = new Set();
    for (let file of files) {
        const mapped = getFileName(file.name);
        const fileName = mapped.split(".")[0];

    
        if (fileName === "notFound") {
            displayLog(`${file.name} is not Identified.`, "error");
            return;
        }

        if (duplicateFiles.has(fileName)) {
            displayLog(`${file.name} is a duplicate and cannot be uploaded again.`, "error");
            return;
        }

        duplicateFiles.add(fileName);
    }

    setUploadedFiles(files);
};


	const validateSelectedFiles = (file) => {

		let flag = SUPPORTED_FILES.some((name) => {
			return file.name.includes(name);
		});


		if (flag) {
			return null;
		} else {
			displayLog(file.name + " is not supported.", "error");
			return true;
		}
	};

	return (
		<div>

			<Box mb={2} >
				<Typography variant="h2" component="h2">
					Import File
				</Typography>
			</Box>
			<Box
				sx={{
					width: '100%',
					border: '1px dashed grey',
					borderRadius: '10px',
					height: '40%',
					minHeight: '300px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',


				}}
			>
				<Dropzone onDrop={(acceptedFiles) => fileDrop(acceptedFiles)} maxSize={config.MAX_FILE_SIZE} accept={"application/vnd.ms-excel, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv, text/xml"} validator={validateSelectedFiles}

				>
					{({ getRootProps, getInputProps }) => (
						<Box
							// css-equivalent - file-upload-section
							component={"section"}
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								height: '100%',
								minHeight: '300px',
								width: '100%',

							}}
						>
							<div {...getRootProps()}
								// new css 
								style={{
									width: "100%",
									height: "100%",
									minHeight: "300px",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",

								}}
							>
								<input {...getInputProps()} accept={"application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv , text/xml"} />
								<Box
									// css-equivalent - file-upload
									sx={{
										minHeight: "100%",
										textAlign: "center",
										width: "100%",
									}}
								>
									<img src={CloudUploadImg} alt="Upload-image" style={{
										width: "100px", // added inline style replacing classname
									}} />
									<Typography>
										Drag Your File or &nbsp;<b>
											<span className="pointer">
												Browse
											</span>
										</b>
									</Typography>
									{/* Added margin-top for spacing */}
									<Typography sx={{ mt: 2 }} variant="body2" color="text.secondary" gutterBottom>
										Supported File (csv, xlsx, xlsb ,xml)
									</Typography>
									<Typography variant="body2" color="text.secondary" gutterBottom>
										Maximum file upload size is 5 MB
									</Typography>
									{uploadedFiles?.length ? (
										<p className="">
											{[...uploadedFiles].map((item, index) => {
												return `${index ? ", " : ""}` + item.name;
											})}
										</p>
									) : (
										<p></p>
									)}
								</Box>
							</div>
						</Box>
					)}
				</Dropzone>
			</Box>
			<Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
				<Button variant="contained" sx={{ marginTop: 2 }} onClick={() => uploadFile()} disabled={loading || !uploadedFiles.length}>
					{loading ? (
						<CircularProgress size={20} />
					) : "Upload"}
				</Button>
				{loading ? <div>File{uploadedFiles && uploadedFiles.length == 1 ? " is" : "s are"} being uploaded, please wait a moment.</div> : ""}

			</Box>
		</div>
	);
};

export default DocketsUpload;